import { render, staticRenderFns } from "./error-system.vue?vue&type=template&id=84bdc4ae&scoped=true&"
import script from "./error-system.vue?vue&type=script&lang=js&"
export * from "./error-system.vue?vue&type=script&lang=js&"
import style0 from "./error-system.vue?vue&type=style&index=0&id=84bdc4ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bdc4ae",
  null
  
)

export default component.exports